export default [
  {
    title: 'Sistema',
    icon: 'ToolIcon',
    action: 'read',
    resource: 'Sistema',
    children: [
      {
        title: 'Usuários',
        route: 'usuarios',
        icon: 'UserIcon',
        action: 'read',
        resource: 'Usuarios',
      },
      {
        title: 'Produtos',
        route: 'apps-produtos-list',
        icon: 'BoxIcon',
        action: 'read',
        resource: 'Produto',
      },
      {
        title: 'Perfil Acesso',
        route: 'perfils',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'PerfilAcesso',
      },
      {
        title: 'Permissões',
        route: 'apps-permissao-list',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'Permissoes',
      },
      // {
      //     title: 'Parametros',
      //     route: 'parametros',
      //     action: 'read',
      //     resource: 'Parametros'
      // },
      {
        title: 'Regras',
        route: 'apps-regra-list',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'Regras',
      },
      {
        title: 'Tabela Extensão',
        route: 'apps-tb-extensao-list',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'Cliente DKP',
      },
      {
        title: 'Campos Customizados',
        route: 'apps-campos-customizado-list',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'CamposCustomizados',
      },
      // {
      //     title: 'Imagem Login',
      //     route: 'apps-imagem-login-list',
      //     icon: 'UsersIcon',
      //     action: 'read',
      //     resource: 'Sistema',
      // },
      {
        title: 'WorkFlow',
        action: 'read',
        resource: 'WorkFlow',
        children: [
          {
            title: 'WorkFlow Áreas',
            route: 'apps-workflow-list',
            action: 'read',
            resource: 'WorkFlowAreas',
          },
          {
            title: 'WorkFlow X Usuários',
            route: 'apps-workflow-usuario-list',
            action: 'read',
            resource: 'WorkFlowUsuarios',
          },
          {
            title: 'WorkFlow Direcionamento',
            route: 'apps-workflow-direcionamento-list',
            action: 'read',
            resource: 'WorkflowDirecionamento',
          },

        ],
      },

    ],
  },
];
